module.exports = __webpack_public_path__ + "static/media/footerAndroid.7c69336d.svg";